// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2F_jg","title":"BackImages_title__3Rd7A","images":"BackImages_images__28ygn"};